import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { AppModal, AppRemixIcon, AppNoInfo } from "@/layout/AppComponents";
import axios from "axios";
import ReactDOMServer from "react-dom/server";
import colors from "../../../../../../../constants/colors";
import { axiosPath } from "../../../../../../../routing/helpers/router";
import * as currentPageAction from "../../../../../../../store/actions/currentPageAction";
import CalendarNewEvent from "../../ExpandedTabs/Calendar/CalendarNewEvent";
import CalendarEvents from "./CalendarEvents";
import Translator from "../../../../../../components/helpers/Translator";

const CalendarBlock = (props) => {
  const { plantObligationID } = props;
  const { moduleBridgeHex, plantHex } = useParams();
  const dispatch = useDispatch();
  const poLevel3 = useSelector(
    (state) => state.currentPage?.plantObligationLevels?.level3
  );
  const calendarTab = useSelector(
    (state) => state.currentPage?.calendarTabs?.[plantObligationID]
  );
  const permissions = useSelector(
    (s) => s.module?.[moduleBridgeHex]?.permissions
  );
  const userBridgePermissions = useSelector(
    (state) => state.module[moduleBridgeHex]?.userBridge?.permissions
  );
  const [showNewEventModal, setShowNewEventModal] = useState(false);

  const handleResolveEvent = async (calendarDateID) => {
    try {
      const response = await axios.post(
        axiosPath("api_r_user_module_legalCompliance_calendar_solveEvent"),
        {
          moduleBridgeHex,
          plantHex,
          plantObligationID,
          calendarDateID,
        }
      );
      dispatch(
        currentPageAction.change("calendarTabs", {
          [plantObligationID]: response.data,
        })
      );
    } catch (err) {}
  };

  return (
    <>
      <h3>
        <Translator file="module-legalCompliance" name="planned.dates" />
        {(!permissions?.gcl?.module?.plant?.calendar?.fullCalendar ||
          permissions?.gcl?.module?.plant?.calendar?.fullCalendar === false) &&
          (userBridgePermissions?.level !== 2 ||
            userBridgePermissions?.writeCalendar === true) && (
            <div>
              <span
                className="pointer d-inline-flex align-items-center text-center pr-1"
                style={{ color: colors.primaryLight, fontWeight: "normal" }}
                onClick={() => setShowNewEventModal(true)}
              >
                <AppRemixIcon
                  className="mr-1"
                  icon="add"
                  color={colors.primaryLight}
                />
                <Translator file="module-legalCompliance" name="add" />
              </span>
              <AppModal
                show={showNewEventModal}
                title={ReactDOMServer.renderToString(
                  <Translator file="module-legalCompliance" name="add.event" />
                )}
                onClose={() => setShowNewEventModal(false)}
                isCloseButton
              >
                <CalendarNewEvent
                  isExternal
                  plantObligationID={plantObligationID}
                  onCreated={() => setShowNewEventModal(false)}
                />
              </AppModal>
            </div>
          )}
      </h3>
      {calendarTab ? (
        calendarTab[0].length === 0 && calendarTab[1].length === 0 ? (
          <AppNoInfo
            separation="0"
            text={ReactDOMServer.renderToString(
              <Translator file="module-legalCompliance" name="without.events" />
            )}
            icon={<></>}
            color={colors.grey500}
          />
        ) : (
          <CalendarEvents
            calendarEvents={calendarTab}
            handleResolveEvent={(v) => handleResolveEvent(v)}
          />
        )
      ) : poLevel3?.[plantObligationID]?.calendar?.events ? (
        poLevel3[plantObligationID]?.calendar?.events[0].length === 0 &&
        poLevel3[plantObligationID]?.calendar?.events[1].length === 0 ? (
          <AppNoInfo
            separation="0"
            text={ReactDOMServer.renderToString(
              <Translator file="module-legalCompliance" name="without.events" />
            )}
            icon={<></>}
            color={colors.grey500}
          />
        ) : (
          <CalendarEvents
            calendarEvents={poLevel3[plantObligationID]?.calendar?.events}
            handleResolveEvent={(v) => handleResolveEvent(v)}
          />
        )
      ) : (
        <AppNoInfo
          separation="0"
          text={`${ReactDOMServer.renderToString(
            <Translator file="module-legalCompliance" name="searching" />
          )}...`}
          icon={
            <AppRemixIcon
              icon="calendar-todo"
              size={30}
              color={colors.grey500}
            />
          }
          color={colors.grey500}
        />
      )}
    </>
  );
};

export default CalendarBlock;
